import logo from "./media/logo.png";
import logoPost from "./media/logoPost.png";
import ceLogo from "./media/ce.png";
import backgroundImage from "./media/background.jpg";
import qaLogo from "./media/logoQA.png";
import footerLogo from "./media/powered-by-healo.png";
import constants from "../../../../common/constants";
import SV_TRANSLATION from "./messages/sv";
import EN_TRANSLATION from "./messages/en";

const isProdEnv = process.env.REACT_APP_ENV === "production";

export default {
  name: "dif",
  image: logo,
  imagePost: logoPost,
  imageQA: qaLogo,
  ceLogo: ceLogo,
  backGroundVideo: null,
  homeTitleSecond: "root.titleSecond",
  appBackground: {
    overlayStyle: {
      opacity: 0.75,
      mixBlendMode: "multiply",
      backgroundColor: "#005eaa"
    },
    url: backgroundImage
  },
  secondaryBackground: {
    backgroundColor: "rgba(211, 244, 245, 0.95)",
    gradientColors: ["rgba(211, 244, 245, 0.95)", "rgba(211, 244, 245, 0.9)"]
  },
  footerImage: footerLogo,
  baseClass: "brand-dif",
  domains: [
    "http://localhost:4005",
    "https://dev-dif.healo.app",
    "https://stg-dif.healo.app",
    "https://dif.healo.app"
  ],
  clinicCityEnabled: false,
  //set clinic id for PROD
  clinicId: isProdEnv ? 1115 : 1107,
  ssnEnabled: true,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: true,
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/dif/settings.js